import React from "react";

import CandidateRightBasicInfo from "./CandidateRightFullProfileInfo/CandidateRightBasicInfo";
import CandidateRightProfile from "./CandidateRightFullProfileInfo/CandidateRightProfile";

const CandidateFullProfileInformation = () => {
  return (
    <div className="CandidateFullProfileInformation_wrapper grid gap-[24px]">
      <CandidateRightBasicInfo />
      <CandidateRightProfile />
      {/* <CandidateRightActions /> */}
    </div>
  );
};

export default CandidateFullProfileInformation;
